<div class="no-sites-container d-flex align-items-center justify-content-center">
    <div class="card no-sites-card text-center p-4 p-md-5">
        <div class="card-body">
            <div class="icon-container mb-4 mx-auto d-flex align-items-center justify-content-center">
                <i class="bi bi-shop font-large-2 primary"></i>
            </div>

            <h2 class="card-title font-large-1 mb-3">{{ 'no_sites.title' | translate }}</h2>

            <p class="card-text grey font-medium-2 mb-5 mx-auto description-text">
                {{ 'no_sites.description' | translate }}
            </p>

            <button class="btn btn-primary btn-lg px-4 py-2 mb-4 d-flex align-items-center mx-auto"
                (click)="onCreateSite()">
                <i class="bi bi-plus font-medium-3 me-2"></i>
                {{ 'no_sites.create_button' | translate }}
            </button>

            <div class="support-link mt-2">
                <span class="grey">{{ 'no_sites.need_help' | translate }} </span>
                <a href="javascript:void(0)" (click)="contactSupport()" class="primary text-bold-500">
                    {{ 'no_sites.contact_support' | translate }}
                </a>
            </div>
        </div>
    </div>
</div>